import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { graph } from "../../../../services/manager-dashboard.service";
import { MultiBarsChart } from "../multi-bars-chart";
import { Container, DashboardSelect, Filters } from "./styles";

interface IDashboardFilterChart {
    isPartner?: boolean
}

interface IGraph {
    graph: {
        week1: {
            current: number;
            previous: number;
        }
        week2: {
            current: number;
            previous: number;
        }
        week3: {
            current: number;
            previous: number;
        }
        week4: {
            current: number;
            previous: number;
        }
    }
}

export const DashboardFilterChart: React.FC<IDashboardFilterChart> = ({ isPartner = false }) => {
    const d = new Date()
    const { t: translation } = useTranslation()
    const [month, setMonth] = useState(d.getMonth() + 1)
    const [type, setType] = useState('totalExternalAcesses')
    const [weekPrevious, setweekPrevious] = useState<number[]>([])
    const [weekCurrent, setWeekCurrent] = useState<number[]>([])


    useEffect(() => {
        graph(type, month).then((res: IGraph) => {
            setweekPrevious([res.graph.week1.previous, res.graph.week2.previous, res.graph.week3.previous, res.graph.week4.previous])
            setWeekCurrent([res.graph.week1.current, res.graph.week2.current, res.graph.week3.current, res.graph.week4.current])
        })
    }, [month, type])

    return (
        <Container>
            <Filters className="mb-3">
                <DashboardSelect>
                    {!isPartner ? (
                        <Form.Select style={{ color: '#6473FF', borderColor: '#6473FF' }} onChange={e => setType(e.target.value)} className="ds-select" defaultValue={type} aria-label={translation('filters.objectType')}>
                            <option value="totalExternalAcesses">{translation('manager.dashboard.filterChart.types.totalExternalAcesses')}</option>
                            <option value="newSubscribers">{translation('manager.dashboard.filterChart.types.newSubscribers')}</option>
                            <option value="totalVisitors">{translation('manager.dashboard.filterChart.types.totalVisitors')}</option>
                            <option value="totalLinks">{translation('manager.dashboard.filterChart.types.totalLinks')}</option>
                            
                        </Form.Select>
                    ) : (
                        <Form.Select style={{ color: '#6473FF', borderColor: '#6473FF' }} onChange={e => setType(e.target.value)} className="ds-select" defaultValue='totalExternalAcesses' aria-label={translation('filters.objectType')}>

                            <option value="totalExternalAcesses">{translation('manager.dashboard.filterChart.types.totalExternalAcesses')}</option>
                            <option value="totalLinks">{translation('manager.dashboard.filterChart.types.totalLinks')}</option>
                            
                        </Form.Select>
                    )}


                </DashboardSelect>
                <DashboardSelect>
                    <Form.Select style={{ color: '#6473FF', borderColor: '#6473FF' }} onChange={e => setMonth(parseInt(e.target.value))} className="ds-select" defaultValue={month} aria-label={translation('filters.objectType')}>
                        <option value="1">{translation('manager.dashboard.filterChart.months.1')}</option>
                        <option value="2">{translation('manager.dashboard.filterChart.months.2')}</option>
                        <option value="3">{translation('manager.dashboard.filterChart.months.3')}</option>
                        <option value="4">{translation('manager.dashboard.filterChart.months.4')}</option>
                        <option value="5">{translation('manager.dashboard.filterChart.months.5')}</option>
                        <option value="6">{translation('manager.dashboard.filterChart.months.6')}</option>
                        <option value="7">{translation('manager.dashboard.filterChart.months.7')}</option>
                        <option value="8">{translation('manager.dashboard.filterChart.months.8')}</option>
                        <option value="9">{translation('manager.dashboard.filterChart.months.9')}</option>
                        <option value="10">{translation('manager.dashboard.filterChart.months.10')}</option>
                        <option value="11">{translation('manager.dashboard.filterChart.months.11')}</option>
                        <option value="12">{translation('manager.dashboard.filterChart.months.12')}</option>
                    </Form.Select>
                </DashboardSelect>
            </Filters>

            <MultiBarsChart type={type} month={month < 10 ? `0${month}` : `${month}`} weekCurrent={weekCurrent} year={d.getFullYear()} weekPrevious={weekPrevious} />
        </Container>
    )
}